import { z } from 'zod';

/* GET /api/badges — unread counts for the bottom-nav tab badges. Polled. */
export const BadgeCountsSchema = z.object({
  /** Whisper threads with unread messages (either side) + pending Spark requests. */
  whispers: z.number().int().nonnegative(),
  /** Circle rooms you're in that have messages you haven't seen. */
  circles: z.number().int().nonnegative(),
  /** Unread notifications ("Alerts" tab). */
  alerts: z.number().int().nonnegative(),
  /** Pro DM conversations with unread messages. 0 for non-Pro users. */
  pro: z.number().int().nonnegative(),
  /** true when this user has an active Nearmirer Pro grant — gates the Pro tab.
   * Rides on the badges poll so the shell needs no separate status request. */
  proActive: z.boolean(),
});
export type BadgeCounts = z.infer<typeof BadgeCountsSchema>;
